import store from './team-manager-store';
import routes from './team-manager-routes';

const components = [];
const mixins = [];
const filters = [];
const directives = [];

export default {
  components,
  mixins,
  filters,
  directives,
  routes,
  store
};



// WEBPACK FOOTER //
// ./src/entities/team-manager/team-manager-module.js